import { get, post } from './common';
import { CatalogCommand, CatalogConfiguration, CatalogFilter, CatalogItem, Classification } from '../Types/mediaCatalog';
import { MediabankFileSettings } from '../Types/mediabank';

type WireFile = {
	id: number;
	name: string;
	description: string | null;
	fileUrl: string;
	fileSource?: string;
	thumbnail: string;
	type: number;
	uploadLocation: number;
	urlRewrite?: string;
	settings?: {
		width: number;
		height: number;
		proportions: number;
		fileSizeKB: number;
		focusX: number;
		focusY: number;
		externalId?: string;
		externalAuthorName?: string;
		externalAuthorUrl?: string;
	};
};

export const getCatalogConfiguration = () => get<CatalogConfiguration>('api/mediacatalog/GetConfiguration');
export const executeCatalogCommand = (command: CatalogCommand) => post<{ success: boolean }>('api/mediacatalog/Execute', command);

export async function searchCatalog(filter: CatalogFilter): Promise<CatalogItem[]> {
	const items = await post<{ file: WireFile; classification: Classification }[]>('api/mediacatalog/Search', filter);
	// Keep the existing picker callback contract; the new endpoint uses camelCase.
	return (items ?? []).map(({ file, classification }) => {
		const settings: MediabankFileSettings | undefined = file.settings
			? {
					Width: file.settings.width,
					Height: file.settings.height,
					Proportions: file.settings.proportions,
					FileSizeKB: file.settings.fileSizeKB,
					FocusX: file.settings.focusX,
					FocusY: file.settings.focusY,
					ExternalId: file.settings.externalId,
					ExternalAuthorName: file.settings.externalAuthorName,
					ExternalAuthorUrl: file.settings.externalAuthorUrl,
				}
			: undefined;
		return {
			classification,
			file: {
				Id: file.id,
				Name: file.name,
				Description: file.description,
				FileUrl: file.fileUrl,
				FileSource: file.fileSource,
				Thumbnail: file.thumbnail,
				Type: file.type,
				UploadLocation: file.uploadLocation,
				UrlRewrite: file.urlRewrite,
				Settings: settings,
			},
		};
	});
}
